/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { VisualEditContrastIcon16Light } from './VisualEditContrastIcon16Light';
import { VisualEditContrastIcon16Regular } from './VisualEditContrastIcon16Regular';
import { VisualEditContrastIcon16Solid } from './VisualEditContrastIcon16Solid';
import { VisualEditContrastIcon20Light } from './VisualEditContrastIcon20Light';
import { VisualEditContrastIcon20Regular } from './VisualEditContrastIcon20Regular';
import { VisualEditContrastIcon20Solid } from './VisualEditContrastIcon20Solid';
import { VisualEditContrastIcon24Regular } from './VisualEditContrastIcon24Regular';
import { VisualEditContrastIcon24Solid } from './VisualEditContrastIcon24Solid';
import { VisualEditContrastIcon32Regular } from './VisualEditContrastIcon32Regular';
import { VisualEditContrastIcon64Regular } from './VisualEditContrastIcon64Regular';
var sizes = {
    16: {
        light: VisualEditContrastIcon16Light,
        regular: VisualEditContrastIcon16Regular,
        solid: VisualEditContrastIcon16Solid,
    },
    20: {
        light: VisualEditContrastIcon20Light,
        regular: VisualEditContrastIcon20Regular,
        solid: VisualEditContrastIcon20Solid,
    },
    24: {
        regular: VisualEditContrastIcon24Regular,
        solid: VisualEditContrastIcon24Solid,
    },
    32: {
        regular: VisualEditContrastIcon32Regular,
    },
    64: {
        regular: VisualEditContrastIcon64Regular,
    },
};
export var VisualEditContrastIcon = forwardRef('VisualEditContrastIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
